module.exports = __webpack_public_path__ + "static/img/3.e76c60b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/3.png
// module id = 9zI6
// module chunks = 0